import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import UserEventsCard from "../Components/UserEventsCard";
import { collection, onSnapshot, query } from "firebase/firestore"; 
import { db } from "../firebase/config";

const MasterclassUsers = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  
  useEffect(() => {
    // Set up real-time listener for all users in the collection
    const usersCollectionRef = collection(db, "user_events_tracking");
    const q = query(usersCollectionRef);
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const userData = [];
      querySnapshot.forEach((doc) => {
        userData.push({
          id: doc.id,
          ...doc.data()
        });
      });
      setUsersData(userData);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching users data:", error);
      setLoading(false);
    });

    // Clean up listener on component unmount
    return () => unsubscribe();
  }, []);

  return (
    <div className="flex flex-col h-[100%]">
      <div className="w-[100%]">
        <Header
          PageName={"Masterclass Users Stats"}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
      <div className="w-full flex items-start bg-primary opacity-75 rounded-sm h-full border border-[#ffffff18]">
        <div className="container mx-auto p-4">
          {loading ? (
            <p className="text-white">Loading users data...</p>
          ) : (
            <div>
              <div className="mb-4">
                <input
                  type="text"
                  placeholder="Search users..."
                  className="w-full md:w-1/3 px-4 py-2 bg-[#2d2d2d] text-white border border-[#444444] rounded-md focus:outline-none focus:border-[#666666]"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              
              <UserEventsCard usersData={usersData} searchTerm={searchTerm} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MasterclassUsers;